export type AnyValue = string | number | boolean | null | undefined | AnyValue[] | { [key: string]: AnyValue };

export function buildQueryString(params: Record<string, AnyValue> | null | undefined, parentKey?: string): string {
  const queryParts: string[] = [];

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];

      if (typeof value === 'undefined') continue;

      if (value === null) {
        queryParts.push(`${key}=`);

        continue;
      }
      const keyName = parentKey ? `${parentKey}${encodeURIComponent(`[${key}]`)}` : encodeURIComponent(key);

      if (Array.isArray(value)) {
        value.forEach((item: AnyValue, index: number) => {
          queryParts.push(buildQueryString({ [index]: item }, keyName));
        });
      } else if (typeof value === 'object') {
        queryParts.push(buildQueryString(value, keyName));
      } else {
        queryParts.push(`${keyName}=${encodeURIComponent(value ?? '')}`);
      }
    }
  }
  return queryParts.join('&');
}
